import * as request from '@/utils/request'
const BASE_URL = '/paas/esign/sms'

export default {
	/**
	 * @description E签宝白名单
	 * @author daihua
	 * @date 2022/4/13
	 * @param {*} data
	 * @returns
	 */
	//创建
	post_esign_whiteList(data) {
		return request.post(`${BASE_URL}/white/list/create`, data)
	},
	//列表
	get_esign_whiteList(data) {
		return request.get(`${BASE_URL}/white/list/index`, data)
	},
    // 修改
    update_esign_whiteList(id,data){
        return request.put(`${BASE_URL}/white/list/update/${id}`,data)
    },
	//删除
	delete_esign_whiteList(id){
		return request.Delete(`${BASE_URL}/white/list/delete/${id}`)
	}
}
